<template>
  <b-form-group :label="label" class="root">
    <b-form-input required :placeholder="label" :value="value" @input="$emit('input', $event)" @focus="showOptions" @blur="hideOptions"/>
    <b-list-group class="options" v-if="optionsVisible">
      <b-list-group-item v-for="(item, $index) in filteredItems" :key="$index" href="#" @mousedown="selectItem(item)">{{item}}</b-list-group-item>
    </b-list-group>
    <b-form-invalid-feedback
      v-if="formErrors && formErrors[fieldName] && formErrors[fieldName].length > 0"
      :state="false"
    >
      <p v-for="(e, $index) in formErrors[fieldName]" :key="$index">{{ e }}</p>
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  data() {
    return {
      optionsVisible: false,
    };
  },
  props: {
    label: {
      required: true,
      type: String,
    },
    fieldName: {
      type: String,
      required: true,
    },
    formErrors: {
      required: false,
      type: Object,
      default: null,
    },
    value: {
      type: [String, Object, null],
      required: true,
      default: '',
    },
    options: {
      type: [Array],
      required: true,
    },
  },
  computed: {
    filteredItems() {
      return this.options.filter(o => o.toLowerCase().indexOf(this.value.toLowerCase()) >= 0);
    },
  },
  methods: {
    showOptions() {
      this.optionsVisible = true;
    },
    hideOptions() {
      this.optionsVisible = false;
    },
    selectItem(item) {
      this.$emit('input', item);
    },
  },
};
</script>

<style lang="less" scoped>
.root {
  position: relative;
}
.options {
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 100;
  max-height: 200px;
  overflow-y: auto;
}
</style>
